import { Badge, ListGroup, ListGroupItemProps } from 'react-bootstrap';

import Button from '@/common/Button';
import { CSSProperties } from 'react';
import HasPermission from '@/components/HasPermission';
import { getClasses } from '@/utils';

type CategoriesListItemProps = ListGroupItemProps & {
  id: string;
  name: string;
  previewStyle?: CSSProperties;
  description: string;
  questionCount: number;
  groupNames?: string[];
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
};

export const CategoriesListItem = ({
  id,
  name,
  previewStyle,
  description,
  questionCount,
  groupNames = [],
  onEdit,
  onDelete,
  className,
  ...props
}: CategoriesListItemProps) => {
  return (
    <ListGroup.Item {...props} className={getClasses('CategoriesListItem', className)}>
      <div className="CategoriesListItem-Header">
        <div className="CategoriesListItem-ColorPreview" style={previewStyle} />
        <div className="CategoriesListItem-Info">
          <span className="CategoriesListItem-Name">{name}</span>
          <span className="CategoriesListItem-Questions">{questionCount} Items</span>
        </div>
        <HasPermission name="allowEditTrainingSettings">
          <div className="CategoriesListItem-Actions">
            <Button
              type="button"
              variant="link"
              className="CategoriesListItem-IconButton"
              aria-label={`Edit ${name}`}
              onClick={() => onEdit?.(id)}
            >
              <i className="sv sv-pencil3" aria-hidden="true" />
            </Button>
            <Button
              type="button"
              variant="link"
              className="CategoriesListItem-IconButton CategoriesListItem-IconButton--danger"
              aria-label={`Delete ${name}`}
              onClick={() => onDelete?.(id)}
            >
              <i className="sv sv-trash2" aria-hidden="true" />
            </Button>
          </div>
        </HasPermission>
      </div>
      <div className="CategoriesListItem-Description">
        <span>{description}</span>
      </div>
      <div className="CategoriesListItem-Groups">
        {groupNames.length > 0 ? (
          [...groupNames].sort().map((groupName) => (
            <Badge key={groupName} bg="gray-subtle" pill>
              {groupName}
            </Badge>
          ))
        ) : (
          <Badge bg="gray-subtle" pill>
            All Evaluators
          </Badge>
        )}
      </div>
    </ListGroup.Item>
  );
};
